module.exports = ".navbar {\n  width: 100%;\n  text-align: center;\n  padding: 12px 0 8px; }\n  .navbar li {\n    position: relative;\n    font-size: 12px !important;\n    text-transform: uppercase; }\n  .navbar li i {\n      display: block;\n      font-size: 24px;\n      margin-bottom: 5px; }\n  .navbar li.active:after {\n      content: '';\n      width: 10px;\n      height: 10px;\n      position: absolute;\n      bottom: -12px;\n      left: 50%;\n      margin-left: -5px;\n      border-radius: 50%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/nav-bar/nav-bar.component.scss
// module id = ./src/app/shared/nav-bar/nav-bar.component.scss
// module chunks = main